
<template>
    <div>
        <Banner />
        <m_hone v-if="flag"/>
        <p_hone v-else/>
    </div>
</template>

<script>
import m_hone from './m_home'
import p_hone from './p_home'
import Banner from '../../components/Banner/index'
import {mapState} from 'vuex';
export default {
    components : {
        m_hone,
        p_hone,
        Banner
    },
    computed:mapState({
        flag : state => state.flag
    }),
}
</script>